export default __webpack_public_path__ + "static/media/ethereum-grey.60a499ec.svg";